import React from 'react';
import { Instagram, Facebook, Linkedin } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container footer-content">
                <div className="footer-logo">BAR BEN ABU</div>
                <div className="social-links">
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={20} /></a>
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook size={20} /></a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><Linkedin size={20} /></a>
                </div>
                <div className="copyright" >
                    © {new Date().getFullYear()} Bar Ben Abu. All rights reserved.
                    <div className="powered-by" style={{ marginTop: '10px', fontSize: '0.8em', opacity: 0.7 }}>
                        Powered by <a href="https://itaysolutions.com" target="_blank" rel="noopener noreferrer">Itay Solutions</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
